module.exports = function(data) {
var __t, __p = '';
__p += '<td colspan="' +
((__t = ( data.colspan )) == null ? '' : __t) +
'">\n    <div class="message">' +
((__t = ( data.message )) == null ? '' : __t) +
'</div>\n</td>\n';
return __p
}